/* AlaMoana — card: hover na bolinha troca a imagem visivel; click vai p/ a URL da cor */
(function(){
  function cardRoot(label){
    var cs = label.closest("color-swatch");
    return cs ? (cs.closest("product-info") || cs.closest(".card") || cs.parentElement) : null;
  }
  // imagem realmente visivel no centro da area da foto do card
  function visibleImg(root){
    var wrap = root.querySelector(".card__media");
    if(!wrap) return null;
    var b = wrap.getBoundingClientRect();
    if(b.width === 0 || b.height === 0) return wrap.querySelector("img");
    var els = document.elementsFromPoint(b.left + b.width / 2, b.top + b.height / 2);
    for(var i=0;i<els.length;i++){
      if(els[i].tagName === "IMG" && wrap.contains(els[i])) return els[i];
    }
    return wrap.querySelector("img");
  }
  function swap(img, url){
    if(!img || !url) return;
    if(img.getAttribute("data-orig-src") === null){
      img.setAttribute("data-orig-src", img.getAttribute("src") || "");
      img.setAttribute("data-orig-srcset", img.getAttribute("srcset") || "");
    }
    img.srcset = url; img.src = url;
    img.classList.remove("lazyload");
  }
  document.addEventListener("mouseover", function(e){
    var t = e.target; if(!t || !t.closest) return;
    var label = t.closest('color-swatch[data-layout="card"] label'); if(!label) return;
    var url = label.getAttribute("data-swatch-img"); if(!url) return;
    var root = cardRoot(label); if(!root) return;
    swap(visibleImg(root), url);
  }, true);
  document.addEventListener("click", function(e){
    var t = e.target; if(!t || !t.closest) return;
    var label = t.closest('color-swatch[data-layout="card"] label'); if(!label) return;
    var href = label.getAttribute("data-href"); if(!href) return;
    var vid = label.getAttribute("data-variant-id");
    if(vid){ href += (href.indexOf("?") >= 0 ? "&" : "?") + "variant=" + vid; }
    // impede o onLabelClick nativo (bubble) de sobrescrever com a URL sem variante
    e.preventDefault();
    e.stopImmediatePropagation();
    e.stopPropagation();
    window.location.href = href;
  }, true);
  document.addEventListener("mouseout", function(e){
    var t = e.target; if(!t || !t.closest) return;
    var cs = t.closest('color-swatch[data-layout="card"]'); if(!cs) return;
    if(e.relatedTarget && cs.contains && cs.contains(e.relatedTarget)) return;
    var root = cs.closest("product-info") || cs.closest(".card") || cs.parentElement;
    if(!root) return;
    var imgs = root.querySelectorAll("img[data-orig-src]");
    for(var i=0;i<imgs.length;i++){
      imgs[i].setAttribute("srcset", imgs[i].getAttribute("data-orig-srcset") || "");
      imgs[i].src = imgs[i].getAttribute("data-orig-src");
    }
  }, true);
})();
